import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import TableMoreMenu from './TableMoreMenu';
import Iconify from '../Iconify';

export default function TableRowActions(props) {
  const { row, actions } = props;

  const [openMenu, setOpenMenuActions] = React.useState(null);

  const handleOpenMenu = (event) => {
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };

  // executes the handler function, passing the row data, and then closes the menu
  const handleClickMenuItem = (fn) => {
    if (typeof fn === 'function') {
      fn(row);
      handleCloseMenu();
    }
  };

  const rowActions = (actions ?? [])
    .map((action, index) => {
      let showAction = true;

      if (typeof action.isVisible === 'function' && !action.isVisible(row)) {
        showAction = false;
      }

      return showAction ? (
        <MenuItem
          key={`table-row-action-menu-${index}`}
          sx={(theme) => ({ paddingY: theme.spacing(2) })}
          onClick={handleClickMenuItem.bind(null, action.handler)}
          disabled={
            typeof action.isDisabled === 'function' && action.isDisabled(row)
          }
        >
          {action.icon && <Iconify icon={action.icon} />}
          {action.text}
        </MenuItem>
      ) : null;
    })
    .filter((exists) => exists);

  if (rowActions.length === 0) {
    return null;
  }

  return (
    <TableMoreMenu
      onClose={handleCloseMenu}
      onOpen={handleOpenMenu}
      open={openMenu}
      actions={rowActions}
    />
  );
}
